import API_URL from '../config/api';

export interface PostcodeLookupResult {
  postcode: string;
  parish?: string;
  district?: string;
  county?: string;
  country?: string;
  addresses: string[];
  manual_entry: boolean;
}

export async function lookupUkPostcode(postcode: string, token: string): Promise<PostcodeLookupResult> {
  const pc = postcode.replace(/\s+/g, '');
  const r = await fetch(`${API_URL}/landlord/postcode/${encodeURIComponent(pc)}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const d = await r.json();
  if (!r.ok) throw new Error(d.error || 'Postcode lookup failed');
  return d;
}
